import "@fortawesome/fontawesome-free/css/all.min.css";
import { alpha, Button, CircularProgress } from "@mui/material";
import { TOOLBAR_BUTTON_SX } from "./toolbarButton";

interface Props {
	label: string;
	/** Font Awesome classes of the file icon. */
	icon: string;
	/** The file format's own colour: text, icon, border and tint all derive from it. */
	color: string;
	onClick: () => void;
	disabled?: boolean;
	loading?: boolean;
}

/**
 * The one style for every export in a report toolbar: white, with text, icon and border
 * in the file format's colour and a soft tint of it on hover, so it reads as secondary
 * next to the filled RESET and the format is recognised at a glance. Same font, size, case, height and corner radius as
 * RESET and the filter fields (the theme's), sized to its label and pushed to the right
 * edge of the box that holds it.
 */
export const ExportButton = ({
	label,
	icon,
	color,
	onClick,
	disabled,
	loading,
}: Props) => (
	<Button
		size="medium"
		variant="outlined"
		disabled={disabled || loading}
		onClick={onClick}
		startIcon={
			loading ? (
				<CircularProgress size={16} color="inherit" />
			) : (
				<i className={icon} />
			)
		}
		sx={{
			...TOOLBAR_BUTTON_SX,
			display: "flex",
			width: "fit-content",
			ml: "auto",
			px: 1.5,
			whiteSpace: "nowrap",
			color,
			borderColor: alpha(color, 0.35),
			bgcolor: "common.white",
			"&:hover": {
				borderColor: alpha(color, 0.5),
				bgcolor: alpha(color, 0.08),
			},
			"&:active": { bgcolor: alpha(color, 0.16) },
			"& .MuiButton-startIcon i": { fontSize: 18 },
			"&.Mui-disabled": { bgcolor: "transparent" },
		}}
	>
		{label}
	</Button>
);
